    import { dispatch } from 'd3'
    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            feeds: [],
            news: null,
            loadingFeeds: false,
        }
    }

    const state = getDefaultState()

    const getters = {
        news: state => {
            return state.news
        },
        feeds: state => {
            return state.feeds
        },
        loadingFeeds: state => {
            return state.loadingFeeds
        },
    }

    const mutations = {
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        feeds: (state, payload) => {
            state.feeds = payload
        },
        news: (state, payload) => {
            state.news = payload
        },
        loadingFeeds: (state, payload) => {
            state.loadingFeeds = payload
        }
    }

    const actions = {

        getFeeds: ({ commit }) => {
            commit('loadingFeeds', true)
            axiosAuth.get('/quests/feed/admin', {
                    headers: {
                        version: 'v1.1'
                    }
                })
                .then(
                    res => {
                        commit('loadingFeeds', false)
                        if (!res.data.message) {
                            commit('feeds', res.data)
                            dispatch('getFeedsByID', res.data._id)
                        }
                    }
                )
                .catch(
                    error => {
                        console.log(error.response)
                        commit('loadingFeeds', false)

                    }
                )
        },

        updateFeed: ({ commit }, payload) => {
            let data = JSON.parse(JSON.stringify(payload))
            data.edit = false
            commit('updating', true)
            axiosAuth.patch('/quests/feed/admin', data)
                .then(
                    () => {
                        commit('updating', false)

                    }
                )
                .catch(
                    error => {
                        console.log(error.response)
                        commit('updating', false)
                    }
                )
        }
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }